<div
    class="landing-background tw-fixed tw-top-0 tw-left-0 tw-z-50 tw-flex tw-h-screen tw-w-screen tw-flex-col tw-overflow-hidden tw-bg-white">
    <div
        class="tw-flex tw-h-16 tw-items-center tw-justify-between tw-bg-white tw-py-2 tw-px-6">
        <div>
            <img
                width="200"
                src="assets/images/cloud4log_log.png"
                alt="cloud4log" />
        </div>

        <div class="tw-flex tw-space-x-2">
            <img
                width="60"
                src="assets/images/GS1-Germany-Logo.svg"
                alt="GS1 Germany" />
            <img
                width="60"
                src="assets/images/BVL123_RZ_Logo_rgb.png"
                alt="BVL" />
        </div>
    </div>

    <div
        class="tw-flex tw-h-20 tw-flex-col tw-items-center tw-justify-center tw-bg-primaryBlue tw-text-center tw-text-3xl tw-font-semibold tw-text-white tw-shadow-xl tw-backdrop-blur">
        <div>{{ 'LANDING.HEADING-1' | translate }}</div>
        <div class="tw-text-xl tw-font-thin">
            {{ 'LANDING.HEADING-2' | translate }}
        </div>
    </div>

    <div
        class="-tw-mt-[37px] tw-flex tw-h-full tw-items-center tw-justify-center tw-overflow-y-auto md:tw-justify-start md:tw-pl-20">
        <div class="tw-flex tw-w-96 tw-flex-col">
            <div
                class="tw-flex tw-w-full tw-flex-col tw-items-center tw-bg-primaryBlue tw-pt-10 tw-pb-7 tw-text-white tw-shadow-xl tw-backdrop-blur">
                <!-- Authentication Loading State -->
                <div class="tw-w-80 tw-text-center">
                    <div
                        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8">
                        <mat-spinner
                            class="tw-mb-6"
                            diameter="60"
                            strokeWidth="4"></mat-spinner>
                        <div class="tw-text-xl tw-font-semibold tw-mb-3">
                            {{ 'LOGIN.AUTHENTICATING-TITLE' | translate }}
                        </div>
                        <div class="tw-text-sm tw-text-white/80 tw-mb-2">
                            {{ 'LOGIN.AUTHENTICATING-DESCRIPTION' | translate }}
                        </div>
                        <div class="tw-text-xs tw-text-white/60">
                            {{ 'LOGIN.PLEASE-WAIT' | translate }}
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="tw-flex tw-w-full tw-flex-col tw-items-center tw-bg-blue-100 tw-py-8 tw-text-primaryBlue">
                <div class="tw-px-4 tw-text-center">
                    <span class="tw-font-semibold">{{
                        'LANDING.PRODUCT-NAME' | translate
                    }}</span>
                    -
                    {{ 'LANDING.LABEL-1' | translate }}
                </div>

                <div class="tw-mt-6 tw-text-center">
                    <div class="tw-text-xl tw-font-semibold">
                        {{ 'LANDING.LABEL-2' | translate }}
                    </div>
                </div>

                <button
                    mat-flat-button
                    class="tw-my-5 tw-hidden tw-bg-primaryBlue tw-px-12 tw-text-white">
                    {{ 'LANDING.REGISTER-BUTTON' | translate }}
                </button>

                <div class="tw-flex tw-flex-col tw-items-center">
                    <a
                        class="!tw-text-primaryBlue"
                        target="_blank"
                        href="http://www.cloud4log.de"
                        >{{ 'LANDING.MORE-LINK' | translate }}
                    </a>
                    <a
                        class="!tw-text-primaryBlue"
                        target="_blank"
                        href="mailto:c4l-support@t-systems.com?subject={{
                            'LANDING.SUPPORT.SUBJECT' | translate
                        }}"
                        >{{ 'LANDING.SUPPORT.TITLE' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div
        class="tw-pointer-events-none tw-absolute tw-bottom-0 tw-right-0 tw-mx-8 tw-my-14 tw-hidden tw-w-52 tw-flex-col tw-items-start md:tw-flex">
        <img
            class="-tw-ml-3 tw-h-[32px]"
            src="assets/images/TSY_Slogan_Basic_3c_n.svg"
            alt="T-Systems" />

        <div class="tw-text-white">
            {{ 'LANDING.LABEL-3' | translate }}
        </div>

        <div class="gradientbg"></div>
    </div>
    <app-unauth-footer page="login-callback"></app-unauth-footer>
</div>
